import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface PlateDTO extends BaseIntDTO {
  plateName: string;
}
